<template>
	<div>
		<div class="data37">
			<div class="data37Til">{{list.data.menuTitle}}</div>
			<div class="data37Box">
				<div class="data37BoxFor" v-for="(item,index) in list.data.content" :key="index">
					<div class="data37BoxForName">{{item.title}}</div>
					<div class="data37BoxForCen">{{item.desc}}</div>
					<div class="data37BoxForImg">
						<img :src="item.cover" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				// list:[
				// 	{
				// 		img:require('@/assets/product/page10/mbc4.png'),
				// 		name:'MBC-4',
				// 		cen:'3.5mm超细主软管'
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/mbc4.png'),
				// 		name:'MBC-5',
				// 		cen:'匹配多种临床需求'
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/mbc4.png'),
				// 		name:'MBC-6',
				// 		cen:'2.6mm超大钳道'
				// 	},
				// ]
			}
		},
		mounted() {
			console.log(this.list)
		},
		methods: {

		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data37 {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 150px;

		.data37Til {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 60px;
		}

		.data37Box {
			display: flex;
			align-items: center;

			.data37BoxFor {
				margin-right: 39px;

				.data37BoxForName {
					font-size: 26px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #000000;
					margin-bottom: 18px;
				}

				.data37BoxForCen {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 300;
					color: #000000;
					margin-bottom: 37px;
				}

				.data37BoxForImg {
					img {
						width: 375px;
						height: 276px;
					}
				}
			}
		}
	}

	@media screen and (max-width:1200px) {
		.data37 {
			width: 100% !important;
			margin-bottom: 0px !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;
			.data37Til{
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}
			.data37Box{
				width: 100%;
				overflow-x: auto;
				.data37BoxFor {
					margin-right: 20px !important;
					min-width: 100%;
					.data37BoxForName {
						font-size: 18px !important;
					}
				
					.data37BoxForCen {
						font-size: 14px !important;
						margin-bottom:20px !important;
					}
				
					.data37BoxForImg {
						img {
							width: 100% !important;
							height: auto !important;
							object-fit: contain;
						}
					}
				}
			}
		}
	}
</style>